'use client';
import 'core-js/features/array/to-sorted';
import 'core-js/features/set/difference';
import 'core-js/features/set/union';
import 'core-js/features/set/intersection';
import 'core-js/features/array/to-reversed';
import 'core-js/features/string/replace-all';

// Polyfill for Promise.withResolvers for Safari < 16.4 https://unifyapps.sentry.io/issues/6787109018?project=4506756395237376
if (typeof Promise !== 'undefined' && typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

/**
 * Here’s a safe, standards-compliant shim (polyfill) for HTMLFormElement.requestSubmit(), which mimics its behavior for browsers like Safari < 16.4 that don’t support it.
 * To support older iOS versions, we need to support Safari < 16.4 on iphone 7 which has last iOS version 15.8.3
 */
function requestSubmitPolyfill() {
  if (!HTMLFormElement.prototype.requestSubmit) {
    HTMLFormElement.prototype.requestSubmit = function requestSubmit(
      this: HTMLFormElement,
      submitter?: HTMLButtonElement | HTMLInputElement,
    ): void {
      if (submitter) {
        if (!(submitter instanceof HTMLElement)) {
          throw new TypeError('The specified element is not a valid HTMLElement.');
        }

        let isSubmitterValid = false;

        if (submitter.tagName === 'BUTTON') {
          // For button elements, the default type is "submit"
          const buttonType = submitter.getAttribute('type') || 'submit';
          isSubmitterValid = buttonType === 'submit';
        } else if (submitter.tagName === 'INPUT') {
          const inputType = submitter.getAttribute('type') || 'text';
          isSubmitterValid = inputType === 'submit' || inputType === 'image';
        }

        if (!isSubmitterValid) {
          throw new TypeError('The specified element is not a submit button.');
        }

        if (!this.contains(submitter)) {
          throw new DOMException(
            'The specified element is not owned by this form element.',
            'NotFoundError',
          );
        }

        submitter.click();
        return;
      }

      // Fallback: create a temporary, hidden submit button
      const tmpSubmit = document.createElement('input');
      tmpSubmit.type = 'submit';
      tmpSubmit.hidden = true;
      this.appendChild(tmpSubmit);
      tmpSubmit.click();
      this.removeChild(tmpSubmit);
    };
  }
}

export function Polyfills() {
  if (typeof HTMLFormElement !== 'undefined') {
    requestSubmitPolyfill();
  }

  // This function exists to ensure the imports above are included
  // You can also add any dynamic polyfill loading logic here if needed
  return null;
}
